import React, { useState } from "react";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { IconButton } from "@material-ui/core";
import { Row, Col, Input, InputGroup, InputGroupAddon, InputGroupText, ModalBody,
  Modal,
  ModalFooter,
  ModalHeader} from "reactstrap";
import Button from "@material-ui/core/Button";
import moment from 'moment';
import { isEmpty, size, isUndefined, filter } from "lodash";
import {deleteSeparateDebitsCall} from "../separate-property/separateProperty.actions"
import { connect } from "react-redux";

const SeparateProperty2ndSection = (props) => {
  const [inputFields, setInputField] = useState(props.data);

  const [showNote, setShowNote] = useState(false);
  const handleShowNote = () => setShowNote(true);
  const handleCloseNote = () => setShowNote(false);

  const handleChangeInput = (index, event) => {
    const values = [...inputFields];
    values[index][event.target.id] = event.target.value;
    setInputField(values);

  }

  const handleAddFields = () => {
    setInputField([...inputFields, { debt_description: "", debts_date_incurred: "", debts_total_owing: "0.0", debts_pdap: "0.0", debts_pdcr: "0.0" }])
  }

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    if (index = 1)
      values.splice(index, 1);
    setInputField(values);
  }

  const ColoredLine = ({ color }) => (
    <hr
      style={{
        borderTop: "2px solid",
        color: "black",
      }}
    />
  );

  const deleteCall = (id, description, descriptionId) => {
    props.deleteSeparateDebitsCall({
      divorce_id: window.localStorage.getItem("divorce_id"),
      debts_id: isUndefined(id) ? filter(props.data, x => x.debt_description === description)[0].debts_id : id,
      asset_brief_description_id: isUndefined(descriptionId) ? filter(props.data, x => x.brief_desc === description)[0].asset_brief_description_id : descriptionId,
      propertyType: 2,
    })
  }


  const getButtonValue = (e, size) => {
    switch (e) {
      case 17:
        return size < 5 ? true : false;
      case 18:
        return size < 4 ? true : false;
      case 19:
        return size < 4 ? true : false;
      case 20:
        return size < 4 ? true : false;
      case 21:
        return size < 6 ? true : false;
      case 22:
        return size < 8 ? true : false;
    
      default:
        return false;
    }
  }

  const showModal = (e, size) => {
    switch (e) {
      case 17:
      if(size === 4){
      handleShowNote()
    }
    break;
      case 18:
      if(size === 3){
      handleShowNote()
    }
    break;
      case 19:
      if(size === 3){
      handleShowNote()
    }
    break;
      case 20:
      if(size === 3){
      handleShowNote()
    }
    break;
      case 21:
      if(size === 5){
      handleShowNote()
    }
    break;
      case 22:
      if(size === 7){
      handleShowNote()
    }
    break;
    
      default:
        return false;
    }
  }

  return (
    <div>
      {!isEmpty(inputFields) && inputFields.map((inputField, index) => (
        <div key={index} >

          <Row>
            <Col xl={6}>
              <b>Debts Show to Whom Owed:</b>
            </Col>
            <Col xl={12}>
              <Input style={{ marginLeft: "2px" }} defaultValue={inputField.debt_description} type="text" id="debt_description"
                onBlur={(e) => { props.handleDescriptionChange(inputFields); handleChangeInput(index, e) }} />
            </Col>
          </Row>

          <Row>
            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
              <br></br>
              <b>Date Incurred:</b>
              <Input defaultValue={(inputField.debts_date_incurred == "1947-01-01") ? "" : moment(inputField.debts_date_incurred).format('YYYY-MM-DD')} type="date" id="debts_date_incurred"
                onChange={(e) => { props.handleDateIncurredChange(inputFields); handleChangeInput(index, e) }} />
            </Col>

            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
              <br></br>
              <b>Total Owing:</b>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>$</InputGroupText>
                </InputGroupAddon>
                <Input defaultValue={inputField.debts_total_owing} type="number" id="debts_total_owing"
                  onBlur={(e) => { props.handleTotalOwingChange(inputFields); handleChangeInput(index, e) }} />
              </InputGroup>
            </Col>
          </Row>

          <Row>
            <Col>
              <br></br>
              <b>Proposal for Division Award or Confirm to:</b>
            </Col>
          </Row>
          <Row>
            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
              <b>Petitioner:</b>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>$</InputGroupText>
                </InputGroupAddon>
                <Input defaultValue={inputField.debts_pdap} type="number" id="debts_pdap"
                  onBlur={(e) => { props.handlePetitionerChange(inputFields); handleChangeInput(index, e) }} />
              </InputGroup>
            </Col>

            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
              <b>Respondent:</b>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>$</InputGroupText>
                </InputGroupAddon>
                <Input defaultValue={inputField.debts_pdcr} type="number" id="debts_pdcr"
                  onBlur={(e) => { props.handleRespondentChange(inputFields); handleChangeInput(index, e) }} />
              </InputGroup>
            </Col>
          </Row>

          <Row>
            <Col xl={12}>
              <IconButton onClick={() => {handleRemoveFields(index); deleteCall(inputField.debts_id, inputField.debt_description, inputField.asset_brief_description_id) }} style={{ float: "right", color: "black", marginTop: "15px" }} >
                <RemoveIcon />
              </IconButton>

              {getButtonValue(props.descriptionId, size(inputFields)) && <IconButton onClick={() => {handleAddFields(); showModal(props.descriptionId, size(inputFields))}} style={{ float: "right", color: "black", marginTop: "15px" }}>
                <AddIcon />
              </IconButton>}

            </Col>
          </Row>
          <ColoredLine />
        </div>
      ))}
      <Modal isOpen={showNote} style={{ marginTop: "200px", marginLeft: "46%" }}>
        <ModalHeader>
        Note:
        </ModalHeader>
        <ModalBody> If you do not have the options to add more, the court form has run out
           of space. You will need to add a separate attachment. Watch your video tutorials
            for more details.
        </ModalBody>
        <ModalFooter>
        <Row style={{marginLeft:"3px"}}>
        <Button
          style={{width:"48%",marginRight:"2px", color: "white", backgroundColor: "Blue" }}
          onClick={handleCloseNote}
        >
          OK
        </Button>
        </Row>
        </ModalFooter>
      </Modal>
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    deleteSeparateDebitsCall: (data) => dispatch(deleteSeparateDebitsCall(data)),
  }
}

export default connect(null, mapDispatchToProps)(SeparateProperty2ndSection);

